import React, { Component } from 'react';

export const Profile = ({title = null, icon = null, subtitle = null, className=""}) => {
    return (
        <div className={`Profile p-2 rounded-md bg-white hover:bg-slate-100 group-focus-visible:bg-slate-50 cursor-pointer transition-colors duration-300 ${className}`}>
            <div className="Profile-inner flex items-center gap-3">
                <div className="app-icon-container">
                    <div className="Profile-app-icon size-8 rounded-sm bg-cover bg-center" style={{backgroundImage: `url(${ icon })`}}></div>
                </div>
                <div className="Profile-meta-container">
                    <div className="Profile-account-title text-foreground font-medium text-sm">
                        { title }
                    </div>
                    <div className="Profile-app-name text-muted-foreground font-normal text-xs">
                        { subtitle }
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Profile;